(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vv-cookie-preferences"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-vv-cookie-preferences]');
    if (!link) return;
    const banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') {
      event.preventDefault();
      banner.showPreferences();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
